import { useSelector } from 'react-redux';
import useSWR from 'swr';
import { getGrowersFromAPI } from '/@/store/growers/apiProviders';
import { getAppInstance } from '/@/store/session/selectors';
import type { PaginatedResponse } from '/@/types/core';
import type { Grower, GrowersFilters } from '/@/types/growers';

export const useGrowers = (
    {
        page,
        pageSize = 10,
        search,
        country,
        cmCrop,
        hasFields,
        hasReports,
        includeChildren = true,
        node,
        nodeType,
        nodeSubtype,
        parentIn,
        ordering,
        year,
        excludeTargetNode = false,
    }: GrowersFilters & { page: number },
    options: { enabled?: boolean } = { enabled: true }
) => {
    const appInstance = useSelector(getAppInstance);
    return useSWR<PaginatedResponse<Grower>>(
        options.enabled
            ? {
                  key: 'useGrowers',
                  page,
                  pageSize,
                  search,
                  country,
                  cmCrop,
                  hasFields,
                  hasReports,
                  includeChildren,
                  node,
                  nodeType,
                  nodeSubtype,
                  parentIn,
                  ordering,
                  appInstance: appInstance.id,
                  year,
                  excludeTargetNode,
              }
            : null,
        getGrowersFromAPI,
        {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            keepPreviousData: true,
        }
    );
};
